<template>
  <div class="user-container">
    <el-page-header @back="goBack" content="用户资料"></el-page-header>
    <el-form label-position="left" inline class="demo-table-expand">
      <el-form-item label="头像">
        <el-image class="avatar" style="width: 40px; height: 40px" :src="userinfo.avatar" alt="avatar"></el-image>
      </el-form-item>
      <el-form-item label="昵称">
        <span v-if="userinfo.nickname != null && userinfo.nickname != ''">{{ userinfo.nickname }}</span>
        <span v-if="userinfo.nickname == null || userinfo.nickname == ''" style="color: #99a9bf;">未设置</span>
      </el-form-item>
      <el-form-item label="手机">
        <span v-if="userinfo.phone != null && userinfo.phone != ''">{{ userinfo.phone }}</span>
        <span v-if="userinfo.phone == null || userinfo.phone == ''" style="color: #99a9bf;">未绑定</span>
      </el-form-item>
      <el-form-item label="微信">
        <span v-if="userinfo.wx_openid != null && userinfo.wx_openid != ''">已绑定</span>
        <span v-if="userinfo.wx_openid == null || userinfo.wx_openid == ''" style="color: #99a9bf;">未绑定</span>
      </el-form-item>
      <el-form-item label="注册日期">
        <span>{{ userinfo.created_at | date }}</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scope>
@import '@/scss/public.scss';

.demo-table-expand {
  background: $color-white;
  padding: 20px;
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>

<script>
import { formatDate } from "@/utils/utils"
import defaultAvatar from "@/assets/default_avatar.png"

export default {
  name: 'Import',
  components: {
  },
   data() {
    return {
      userinfo: {avatar: defaultAvatar},
    }
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getUserInfo(){
      this.$axios({
        method : "get",
        url : "/api/account/info",
      }).then(res => {
        if(res.status == 200 && res.data.status.code == 0) {
          this.userinfo = res.data.result;
        } else {
          this.$message('获取用户信息失败');
        }
      })
    },
  },
  computed: {
    currentBook() {
      return this.$store.state.currentBook;
    },
  },
  filters: {
    date(value) {
      if(value == null) return "";
      let date = new Date(value);
      return formatDate(date, "yyyy-MM-dd")
    },
  }
}
</script>